import { ReactNode } from 'react';
import Button from './Button';

interface EmptyStateProps {
  icon: React.ElementType;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick?: () => void;
    href?: string;
  };
  children?: ReactNode;
}

export default function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  children,
}: EmptyStateProps) {
  return (
    <div className="relative overflow-hidden rounded-2xl border-2 border-dashed border-gray-200 bg-gradient-to-br from-gray-50 to-white py-16 px-6 text-center">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-24 -right-24 w-64 h-64 bg-kenagri-100/40 rounded-full blur-3xl" />
        <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-blue-100/40 rounded-full blur-3xl" />
      </div>

      <div className="relative">
        {/* Icon container */}
        <div className="mx-auto w-16 h-16 rounded-2xl bg-gradient-to-br from-gray-100 to-gray-50 shadow-soft flex items-center justify-center mb-5">
          <Icon className="h-8 w-8 text-gray-400" />
        </div>

        {/* Title */}
        <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>

        {/* Description */}
        {description && (
          <p className="text-gray-500 max-w-sm mx-auto mb-6">{description}</p>
        )}

        {/* Action button */}
        {action && (
          action.href ? (
            <a href={action.href}>
              <Button variant="primary" size="md">
                {action.label}
              </Button>
            </a>
          ) : (
            <Button variant="primary" size="md" onClick={action.onClick}>
              {action.label}
            </Button>
          )
        )}

        {/* Custom children */}
        {children}
      </div>
    </div>
  );
}
